export default "__VITE_ASSET__528ciJdX__"